import { createBrowserRouter, type RouteObject } from "react-router-dom";

import { AppShell } from "@/components/layout/AppShell";
import { FormFlowShell } from "@/components/layout/FormFlowShell";
import { NotificationStreamGate } from "@/components/layout/NotificationStreamGate";
import { AppRouteErrorBoundary } from "@/components/shared/AppRouteErrorBoundary";
import { RequireActiveAccess } from "@/components/shared/RequireActiveAccess";
import { RequireAuth } from "@/components/shared/RequireAuth";
import { SettingsShell } from "./router/lazyPages/settings";
import { NotFound } from "./router/lazyPages/shared";
import { homeFormRoutes, homeShellRoutes } from "./router/routes/homeRoutes";
import { notFoundRoute, publicRoutes } from "./router/routes/publicRoutes";
import {
  projectCreateRoute,
  projectMutableFormRoute,
  projectShellRoute,
  projectsListRoute,
} from "./router/routes/projectRoutes/projectRoutes";
import {
  settingsFormRoutes,
  settingsLegacyRedirects,
  settingsShellRoutes,
} from "./router/routes/settingsRoutes/settingsRoutes";
import { standaloneRoutes } from "./router/routes/standaloneRoutes";

const appRoutes: RouteObject[] = [
  ...publicRoutes,

  {
    element: <RequireAuth />,
    children: [
      {
        element: <RequireActiveAccess />,
        children: [
          {
            element: <NotificationStreamGate />,
            children: [
              {
                element: <AppShell />,
                handle: { sidebar: "app" },
                children: [
                  ...homeShellRoutes,
                  projectsListRoute,
                  projectCreateRoute,
                  ...settingsLegacyRedirects,
                  {
                    path: "/settings",
                    handle: { sidebar: "settings" },
                    element: <SettingsShell />,
                    children: settingsShellRoutes,
                  },
                  projectShellRoute,
                  { path: "*", element: <NotFound /> },
                ],
              },
              {
                element: <FormFlowShell />,
                children: [
                  ...settingsFormRoutes,
                  ...homeFormRoutes,
                  projectMutableFormRoute,
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  ...standaloneRoutes,

  notFoundRoute,
];

export const router = createBrowserRouter([
  { errorElement: <AppRouteErrorBoundary />, children: appRoutes },
]);
